import PropTypes from 'prop-types';
import React from 'react';

import { currencyCodeValues, regionValues } from '../../../../utils/static/sls-property-values';
import { CustomPanel, Select } from '../../../reusable';

/* display form contents...
 * if adding
 * if there exists an error on any of the fields that we validate
 * note: we use !! to force consideration of prop as bool
 */
const calculateIsOpen = (properties) => (properties.adding
  || !!properties.formErrors.currencyCode || !!properties.formErrors.region);

class Localization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: calculateIsOpen(props),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.formErrors !== this.props.formErrors) {
      if (this.state.isOpen) { return; }
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ isOpen: calculateIsOpen(this.props) });
    }
  }

  panelToggle = () => this.setState((prevState) => ({ isOpen: !prevState.isOpen }));

  render = () => (
    <CustomPanel
      isOpen={this.state.isOpen}
      label="Localization"
      onClick={this.panelToggle}
    >
      <Select
        className="ncss-col-sm-6 va-sm-t"
        errorMessage={this.props.formErrors.currencyCode}
        id="currencyCode"
        isDisabled={this.props.userIsReadOnly}
        label="Currency Code"
        options={currencyCodeValues.map((value) => ({ label: value, value }))}
        value={this.props.formData.currencyCode || ''}
        zIndex={15}
        onChange={(value) => this.props.updateFormData('currencyCode', value)}
      />
      <Select
        className="ncss-col-sm-6 va-sm-t"
        errorMessage={this.props.formErrors.region}
        id="region"
        isDisabled={this.props.userIsReadOnly}
        label="Region"
        options={regionValues.map((value) => ({ label: value, value }))}
        value={this.props.formData.region || ''}
        zIndex={15}
        onChange={(value) => this.props.updateFormData('region', value)}
      />
    </CustomPanel>
  );
}

Localization.propTypes = {
  // ignoring eslint even though the prop is used
  // eslint-disable-next-line react/no-unused-prop-types
  adding: PropTypes.bool.isRequired,
  formData: PropTypes.shape().isRequired,
  formErrors: PropTypes.shape().isRequired,
  updateFormData: PropTypes.func.isRequired,
  userIsReadOnly: PropTypes.bool.isRequired,
};

export default Localization;
